"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var NewModalFooter = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        // paddingTop: theme.spacing(2),
        flexDirection: 'row',
        gap: theme.spacing(2),
        alignItems: 'center',
        paddingTop: theme.spacing(2),
        '> :nth-last-child(2)': {
            maxWidth: "calc(50% - ".concat(theme.spacing(1), ")"),
            flex: 1,
        },
        '> :last-child': {
            minWidth: "calc(50% - ".concat(theme.spacing(1), ")"),
        },
        '> :last-child:first-child': {
            width: '100%',
        },
        // '> *': {
        //   flexGrow: 1,
        // },
        // justifyContent="center"
    });
});
exports.default = NewModalFooter;
